import { useEffect, useState, useRef, FC, PropsWithChildren, CSSProperties } from 'react';
import styles from './index.module.less';

interface IProps {
  key: string;
  show: boolean;
  style?: CSSProperties;
  time?: number;
}

const HeightTransition: FC<PropsWithChildren<IProps>> = ({ children, style, key, time = 0.2, show }) => {
  // 容器ref，用来获取容器里内容的高度
  const containerRef = useRef<HTMLDivElement>(null);
  // 设置容器的高度
  const [height, setHeight] = useState(0);

  // 不支持ResizeObserver
  const noSupportResizeObserver = typeof ResizeObserver === 'undefined';

  useEffect(() => {
    if (!containerRef.current || !show || noSupportResizeObserver) return;
    const resizeObserver = new ResizeObserver(() => {
      setHeight(() => {
        return containerRef.current?.scrollHeight || 0;
      });
    });
    resizeObserver.observe(containerRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [show, noSupportResizeObserver]);

  return noSupportResizeObserver ? (
    <div>{show ? children : null}</div>
  ) : (
    <div
      className={styles.wrapper}
      style={{ ...style, height: show ? height : 0, transition: ` height ${time}s ease-in-out` }}
      key={`transition-${key}-wrapper`}
    >
      <div className={styles.child} ref={containerRef} key={`transition-${key}-child`}>
        {children}
      </div>
    </div>
  );
};

export default HeightTransition;
